<template>
  <div>
    <div class="summary">
      <el-row>
        <el-col :span="12"><span style="color: darkred">未消耗积分:{{totalPoint}}</span></el-col>
      </el-row>
    </div>
    <!--搜索条件-->
    <div class="searchbar">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="手机号码">
          <el-input v-model="filters.cellphone" placeholder="手机号码"></el-input>
        </el-form-item>
        <el-form-item label="只查看充值会员">
          <el-select filterable v-model="filters.isRecharge" placeholder="请选择" clearable>
            <el-option
                v-for="item in enableOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="findPage()">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--表格栏-->
    <div class="table-wrap">
      <el-table :data="tableData.data" stripe highlight-current-row max-height="460" size="small"
                style="width:100%;">
        <el-table-column type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column v-for="column in columns" header-align="center" align="center"
                         :prop="column.prop" :label="column.label" :width="column.width"
                         :min-width="column.minWidth"
                         :fixed="column.fixed" :key="column.prop" :type="column.type">
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right" header-align="center"
                         align="center">
          <template slot-scope="scope">
            <i class="icon-xs icon-hot offset-left30" title="新增积分" @click="handleAdd(scope.$index, scope.row)"></i>
            <i class="icon-xs icon-cold offset-left30" title="扣减积分"
               @click="handleSubstract(scope.$index, scope.row)"></i>
            <i class="icon-xs icon-setting offset-left30" title="积分历史" @click="curve(scope.$index, scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding:10px;">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="refreshPageRequest"
                       :current-page="pageRequest.pageNum" :page-size="pageRequest.pageSize"
                       :total="tableData.totalSize" style="float:right;">
        </el-pagination>
      </div>
    </div>

    <el-dialog v-dialogDrag :title="operation==='add'?'新增积分':'扣减积分'" width="40%" :visible.sync="dialogVisible"
               :close-on-click-modal="false">
      <el-form :model="integralForm" :rules="rules" label-width="80px" ref="integralForm" size="small"
               label-position="right">
        <el-form-item label="userId" prop="userId" v-if="false">
          <el-input v-model="integralForm.userId" :disabled="true" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="note">
          <el-input v-model="integralForm.note" auto-complete="off" @input="change($event)"></el-input>
        </el-form-item>
        <el-form-item label="变更积分" prop="changeIntegral">
          <el-input v-model="integralForm.changeIntegral" auto-complete="off" @input="change($event)"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click.native="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm()">确认</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>

export default {
  name: 'homepage',
  data() {
    return {
      iconLine: require('@/assets/images/icon-chart-sm.png'),
      totalPoint:0,
      filters: {
        cellphone: null,
        isRecharge:'false'
      },
      enableOptions: [
        {
          value: 'true',
          label: '是'
        }, {
          value: 'false',
          label: '否'
        }],
      tableData: {
        'totalSize': 0,
        'data': []
      },
      columns: [
        {prop: 'nickname', label: '昵称', minWidth: 120},
        {prop: 'cellphone', label: '手机号码', minWidth: 120},
        {prop: 'totalIntegral', label: '总积分', minWidth: 100},
        {prop: 'createdAt', label: '注册时间', minWidth: 120},
      ],
      pageRequest: {
        pageNum: 1,
        pageSize: 10
      },
      dialogVisible: false,
      dialogResetVisible: false,
      operation: '',
      integralForm: {
        changeIntegral:'',
        note:''
      },
      rules: {
        note: [
          {required: true, message: '请输入描述', trigger: 'blur'}
        ],
        changeIntegral: [
          {pattern: /^[0-9.]*$/, message: '变更积分必须为数字值'},
          {required: true, message: '请输入变更积分', trigger: 'blur'},
        ],
      },
    }
  },
  methods: {
    change() {
      this.$forceUpdate()
    },
    // 分页查询
    findPage() {
      let userRequestData = {
        cellphone: this.filters.cellphone,
        isRecharge:this.filters.isRecharge,
        pageNo: this.pageRequest.pageNum,
        pageSize: this.pageRequest.pageSize,
      };
      this.$api.user.selectUser(userRequestData).then((res) => {
        this.tableData.totalSize = res.total;
        this.tableData.data = res.list;
      });

      this.$api.integralItem.selectTotalIntegralItem({}).then((res) => {
        this.totalPoint = res;
      });
    },
    // 换页刷新
    refreshPageRequest: function (pageNum) {
      this.pageRequest.pageNum = pageNum;
      this.findPage()
    },
    // 查看积分历史
    curve(index, row) {
      let routerParam = {
        userId: row.userId,
        cellphone: row.cellphone + ''
      }
      this.$router.push({
        path: 'integralItem',
        query: {
          param: encodeURIComponent(JSON.stringify(routerParam))
        }
      })
    },
    submitForm() {
      this.$refs['integralForm'].validate((valid) => {
        if (valid) {
          let requestData = {
            userId: this.integralForm.userId,
            note: this.integralForm.note,
            changeIntegral: this.integralForm.changeIntegral,
          };

          if (this.operation === 'add') {
            requestData.type = 'add'
            this.$api.integralItem.insertIntegralItem(requestData).then(() => {
              this.dialogVisible = false;
              this.$refs['integralForm'].resetFields();
              this.$message.success('添加积分成功');
              this.findPage();
            });
          } else {
            requestData.type = 'substract'
            this.$api.integralItem.insertIntegralItem(requestData).then(() => {
              this.dialogVisible = false;
              this.$refs['integralForm'].resetFields();
              this.$message.success('扣减积分成功');
              this.findPage();
            });
          }
        } else {
          this.$message.error('验证失败');
          return false;
        }
      });
    },
    handleAdd: function (index, row) {
      this.dialogVisible = true;
      this.operation = 'add';
      this.integralForm.userId = row.userId;
      this.integralForm.changeIntegral = ''
      this.integralForm.note = '储值'
    },
    handleSubstract: function (index, row) {
      this.dialogVisible = true;
      this.operation = 'substract';
      this.integralForm.note = ''
      this.integralForm.changeIntegral = ''
      this.integralForm.userId = row.userId;
    },

  },
  components: {},
  mounted() {
    this.refreshPageRequest(1)
  },
}
</script>

<style scoped>


</style>